import { client } from '@api/client';
import { URL } from '@api/urls';

import { ICount } from '@interfaces/common/common';
import { IGroupOperationDTO, TAllPages } from '@interfaces/common/defaultDTO';
import { ICartRequestDatesPicked } from '@interfaces/rent/assetCart';
import {
	IAssetCartDropdownsData,
	IAssetCartRequestShortView,
	IAssetRentRequestCardItem,
} from '@interfaces/rent/assetRent';
import {
	IAssetCartRequestDTO,
	IAssetCartRequestShortViewDTO,
	ISendAssetCartRequestDTO,
} from '@interfaces/rent/dto/assetCartDTO';

type TAssetCartRequestListResponse = TAllPages<IAssetRentRequestCardItem> & {
	assetOwners: {
		ownerName: string;
		assetCount: number;
	}[];
}

const {
	assetCart,
	assetCartRequestDropdowns,
	assetCartRequest,
	assetCartRequestCount,
	rentRequestsCard,
} = URL;

interface IUpdateAssetCartItem {
	assetId: string;
	dto: {
		assetDbId: string;
		from?: number;
		to?: number;
	};
}

export const getAssetCartRequestDropdowns = (): Promise<IAssetCartDropdownsData> => {
	return client.get(assetCartRequestDropdowns);
};

export const getAssetCartRequestList = (
	data: IAssetCartRequestDTO,
): Promise<TAssetCartRequestListResponse> => {
	return client.get(assetCartRequest, {
		params: data,
	});
};

export const getAssetCartRequestListShortView = ({
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	searchValue,
	assetOwnerId,
	assetTypeId,
	isAvailableInPeriod,
}: IAssetCartRequestShortViewDTO): Promise<TAllPages<IAssetCartRequestShortView>> => {
	return client.get(assetCartRequest, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			assetOwnerId,
			assetTypeId,
			isAvailableInPeriod,
		},
	});
};

export const getAssetCartRequestCount = (): Promise<ICount> => {
	return client.get(assetCartRequestCount);
};

export const deleteAssetsFromCart = ({
	filter,
	ids,
	isAll,
}: IGroupOperationDTO<IAssetCartRequestDTO | null>) => {
	return client.post(`${assetCart}/delete`, {
		filter,
		ids,
		isAll,
	});
};

export const sendAssetCartRequest = ({ comments }: ISendAssetCartRequestDTO): Promise<void> =>
	client.get(`${assetCart}/checkout`, {
		params: {
			comments: comments || null,
		},
	});

export const updateAssetCartItem = ({ assetId, dto }: IUpdateAssetCartItem): Promise<void> =>
	client.put(`${assetCart}/${assetId}`, dto);

export const getAlreadyPickedDatesForRequest = (assetDbId: string): Promise<ICartRequestDatesPicked> =>
	client.get(`${rentRequestsCard}/${assetDbId}/dates-picked`);

export const getAlreadyPickedDatesForUpdate = (assetId: string): Promise<ICartRequestDatesPicked> => {
	return client.get(`${rentRequestsCard}/${assetId}/dates-picked/update`);
};
